import { UrlsConfig } from '../app/config/urls.config';

export const environment = {
  production: false,
  appVersion: 'v2.5.1',
  USERDATA_KEY: 'authf649fc9a##vv235666j5f55_DEV',
  isMockEnabled: false,
  apiUrl: UrlsConfig.API_ENDPOINT,
  env:"DEV"
};
